import { render, staticRenderFns } from "./NominationList.vue?vue&type=template&id=cf4dc3b8&scoped=true"
import script from "./NominationList.vue?vue&type=script&lang=js"
export * from "./NominationList.vue?vue&type=script&lang=js"
import style0 from "./NominationList.vue?vue&type=style&index=0&id=cf4dc3b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4dc3b8",
  null
  
)

export default component.exports